// extracted by mini-css-extract-plugin
export default {"title":"SubsidyInfo_title__zpY5g","content":"SubsidyInfo_content__5xsnY","footer":"SubsidyInfo_footer__qoWSe","placeHolderShimmer":"SubsidyInfo_placeHolderShimmer__8Mbb+"};